import React from 'react';
import { PlayIcon } from '@fronton/icons-react';
import { cn } from 'utils';
import { root, active, icon } from './styles';

const DATA_QA_PLAY_VIDEO_ICON = 'play-video-icon';
export const DATA_QA_PLAY_VIDEO = 'play-video';

type Props = {
  isActive: boolean;
  onClick: () => void;
};

function PlayVideo({ isActive, onClick }: Props) {
  return (
    <div data-qa={DATA_QA_PLAY_VIDEO} className={cn({ [root]: true, [active]: isActive })} onClick={onClick}>
      <PlayIcon
        className={icon}
        type="fill"
        color={isActive ? 'background-primary' : 'control-primary'}
        size="s"
        data-qa={DATA_QA_PLAY_VIDEO_ICON}
      />
    </div>
  );
}

export { PlayVideo };
